// src/data/exercises/L5_05.js

const accountOptions = [
  '普通預金', '定期預金', '受取利息', '支払利息', '未払利息'];

export const L5_05 = {
  title: '簿記　3級（第214-5回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

     parts: [
    { "type": "ruby", "text": "本日", "ruby": "ほんじつ" },
    { "type": "text", "value": "、" },
    { "type": "ruby", "text": "定期預金", "ruby": "ていきよきん" },
    { "type": "text", "value": "￥4,000,000が" },
    { "type": "ruby", "text": "満期日", "ruby": "まんきび" },
    { "type": "text", "value": "となり、" },
    { "type": "ruby", "text": "定期預金口座", "ruby": "ていきよきんこうざ" },
    { "type": "text", "value": "から￥4,000,000とほかに" },
    { "type": "ruby", "text": "満期利息額", "ruby": "まんきりそくがく" },
    { "type": "text", "value": "￥4,000が" },
    { "type": "ruby", "text": "普通預金口座", "ruby": "ふつうよきんこうざ" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "振", "ruby": "ふ" },
    { "type": "text", "value": "り" },
    { "type": "ruby", "text": "替", "ruby": "か" },
    { "type": "text", "value": "えられた。" }
]
      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '普通預金', debitAmount: 4004000, creditAccount: '定期預金', creditAmount:4000000 },
        { debitAccount: null, debitAmount: null, creditAccount: '受取利息', creditAmount: 4000 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '定期預金口座から￥4,000,000」\n' },
          { type: 'styled', value: '①定期預金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
         
          { type: 'text', value: '「普通預金口座に」\n' },
          { type: 'styled', value: '②普通預金の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '「満期利息額￥4,000」\n' },
          { type: 'styled', value: '③普通預金に入っているので、受取利息が増加（プラス）貸方（右・Ｃｒ）', color: 'red', bold: true },
        ]

      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
「定期預金口座から￥4,000,000」
①定期預金の減少（マイナス）します。

「普通預金口座に」
②普通預金の増加（プラス）します。

「満期利息額￥4,000」
③普通預金に入っているので、受取利息が増加（プラス）します。


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {

           parts: [
          { type: 'text', value: '定期預金口座から￥4,000,000」\n' },
          { type: 'styled', value: '①定期預金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
         
          { type: 'text', value: '「普通預金口座に」\n' },
          { type: 'styled', value: '②普通預金の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '「満期利息額￥4,000」\n' },
          { type: 'styled', value: '③普通預金に入っているので、受取利息が増加（プラス）貸方（右・Ｃｒ）', color: 'red', bold: true },
        ]

          }
        ],
       
      },
    },
  ],
};